var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"bottom-actions",style:({direction: _vm.params.direction})},_vm._l((_vm.params.actions),function(action){return _c('v-btn',{key:action.action,attrs:{"text":""},on:{"click":function($event){return _vm.actionClicked(action)}}},[_vm._v(_vm._s(action.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }